import {type TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'

export abstract class UIDeviceInfoPopup extends ViewPopup {
    constructor(additionalInfo: string) {
        const title: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: `Debug Device Info`}}
        const dimensions = `<b>Dimensions: </b> ${document?.body?.clientWidth} x ${document?.body?.clientHeight} <br/>`
        const userAgent = `<b>UA: </b> ${navigator?.userAgent}  <br/>`
        const bodyText = dimensions + userAgent + additionalInfo
        const body: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: bodyText}}

        super(title,
            body,
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showCheckButton: false, showXButton: false})
    }
}
